export var isAndroid = function () { return /android/i.test(navigator.userAgent); };
